import { Button } from "antd";

export default function BotonSubmit({ tituloBoton, onClick, disabled, icon, loading }) {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className="botonSubmit"
      icon={icon}
      loading={loading}
    >
      {tituloBoton}
    </Button>
  );
}
